import React from 'react';
import { useNavigate } from 'react-router-dom';

interface AuthButtonsProps {
  onSignIn: () => void;
}

export const AuthButtons: React.FC<AuthButtonsProps> = ({ onSignIn }) => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center gap-3">
      <button
        onClick={onSignIn}
        className="px-4 py-2 text-sm font-medium text-gray-700 hover:text-primary-600 transition-all duration-300 transform hover:scale-105"
      >
        Sign In
      </button>
      <button
        onClick={() => navigate('/register')}
        className="px-4 py-2 text-sm font-semibold text-white bg-primary-500 rounded-xl hover:bg-primary-600 transition-all duration-300 shadow-soft hover:shadow-large transform hover:scale-105"
      >
        Get Started
      </button>
    </div>
  );
}; 